<template>
    <header class="border-b main-header bg-[color:var(--background)]">
        <!-- <div class="fixed bottom-3 right-3 hidden sm:block" v-if="showDiscord">
            <div class="w-full flex flex-row-reverse">
                <button class="justify-end" @click="showDiscord = false">
                    <Icon name="material-symbols:cancel-outline"
                        class="justify-end text-right font-extralight text-light-gray hover:text-medium-gray" />
                </button>
            </div>
            <a href="https://discord.gg/85z7HF7JbD" target="_blank"
                class="btn btn-sm btn-primary shadow-lg opacity-80 hover:opacity-100">
                Chat with us on Discord
                <Icon name="ic:baseline-discord" class="text-xl ml-2" />
            </a>
        </div>
        <div class="fixed bottom-0 left-0 w-full sm:hidden" v-if="showDiscord">
            <div class="w-full flex flex-row-reverse">
                <button class="justify-end" @click="showDiscord = false">
                    <Icon name="material-symbols:cancel-outline"
                        class="justify-end text-right font-extralight text-light-gray hover:text-medium-gray" />
                </button>
            </div>
            <a href="https://discord.gg/85z7HF7JbD" target="_blank"
                class="btn btn-sm btn-primary shadow-lg rounded-none w-full text-center opacity-90 hover:opacity-100">
                Chat with us on Discord
                <Icon name="ic:baseline-discord" class="text-xl ml-2" />
            </a>
        </div> -->

        <div class="flex items-center justify-between py-3 lg:p-0">
            <div class="flex">
                <a href="/">
                    <img src="/images/Unified_Logo_Black_White_Text.svg" alt="Unified.to" class="h-14 object-contain" />
                </a>

                <!-- <div class="hidden md:inline-flex ml-8 items-center justify-left">
                    <Badge label="BETA" border="border-[var(--primary-blue)]" fg="text-primary-white" />
                </div> -->
            </div>

            <div class="lg:hidden">
                <button @click="isOpen = !isOpen" type="button" :aria-label="isOpen ? 'Close menu' : 'Open menu'"
                    :aria-expanded="isOpen"
                    class="float-right block text-[var(--medium-gray)] hover:text-[var(--dark-gray)] focus:text-[var(--white)] focus:outline-none">
                    <svg class="h-6 w-6 fill-current" viewBox="0 0 24 24">
                        <path v-show="isOpen" fill-rule="evenodd"
                            d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z" />
                        <path v-show="!isOpen" fill-rule="evenodd"
                            d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z" />
                    </svg>
                </button>
            </div>
        </div>

        <nav v-if="isOpen" :class="isOpen ? 'block' : 'hidden'"
            class="absolute left-0 w-full pb-8 background v-full z-50">
            <div class="px-2 pt-2 pb-4 lg:flex lg:p-0 lg:items-center bg-slate-800 w-full">
                <div v-for="item in NAV_MENU.concat(login_menu)" :key="item.title" class="px-1 w-full">
                    <HoverMenuMobile :item="item" />
                </div>

            </div>
        </nav>

        <nav v-if="!isOpen" :class="isOpen ? 'block' : 'hidden'" class="lg:block w-full">
            <div class="px-2 pt-2 pb-4 lg:flex lg:p-0 lg:items-center">
                <div class="w-full flex flex-row justify-center">
                    <Search v-if="isOpen" class="hidden xl:block w-40" />
                    <div v-for="item in NAV_MENU" :key="item.title" class="px-1">
                        <HoverMenu2 :header="item" :columns="item.title === 'Solutions' ? 3 : undefined" />
                    </div>
                    <!-- <div v-for="item in navigation_menu" :key="item.name" class="px-1">
                        <HoverMenuItem :item="item" />
                    </div> -->
                    <Search v-if="!isOpen" class="hidden xl:block w-10" />
                </div>
                <div v-for="item in login_menu" :key="item.title" class="px-1" :class="isOpen ? 'float-right' : ''">
                    <HoverMenu2 :header="item" />
                </div>
            </div>
        </nav>
    </header>
</template>

<script lang="ts">
import { INTEGRATIONS_COUNT_10s, NEW_CATEGORIES } from '~~/services/integrations';
import { MAP_CATS, META_CATEGORIES } from '~~/services/categories';
import { type IMenuItem } from '~~/services/common';
import { type TIntegrationCategory } from '~/models/Unified';
import type { TMenu, TMenuItem } from '~/components/HoverMenu2.vue';

// const CATEGORIES = [...IntegrationCategory].filter(c => c !== 'auth' && c !== 'scim' && c !== 'passthrough' && c !== 'metadata' && MAP_CATS[c]).map((cat) => ({
//     name: `Unified ${(MAP_CATS as any)[cat]} API`,
//     link: `/${cat}`,
//     badge: NEW_CATEGORIES.includes(cat) ? 'New' : undefined,
// })).sort((a, b) => a.name.localeCompare(b.name));

const CLUSTERS: Record<string, (TIntegrationCategory | 'erp' | 'pos')[]> = {
    "Human Resources": ['hris', 'ats', 'lms', 'verification', 'assessment', 'performance', 'erp'],
    "Finance & Commerce": ['accounting', 'commerce', 'payment', 'shipping', 'pos'],
    "Knowledge & Development": ['storage', 'kms', 'repo', 'datastore', 'genai'],
    "Sales & Marketing": ['crm', 'martech', 'enrich', 'ads', 'forms', 'clubs', 'analytics', 'cdp', 'social'],
    "Support": ['ticketing', 'uc'],
    "Productivity": ['messaging', 'calendar', 'task', 'signing', 'legal'],
}

// const menu_header_style = 'text-bold text-md uppercase mb-4 text-white w-full border-b border-gray-800 pb-4';
const menu_subheader_style = 'text-bold text-md mb-4 text-white';
const unifiedapi_style = 'text-gray-300 border-l border-gray-800 pl-4';

const unified_apis: TMenuItem[] = [
    ...Object.entries(CLUSTERS).map(([name, categories]) => ({
        title: name,
        class: menu_subheader_style,
        container_class: 'mb-2 mt-2',
        items: categories.map(c => ({ class: unifiedapi_style, title: `${MAP_CATS[c as keyof typeof MAP_CATS] || c.toUpperCase()}`, link: `/${c}`, badge: NEW_CATEGORIES.includes(c as any) ? 'New' : undefined } satisfies TMenuItem)),
    })),
];
unified_apis.push({
    title: 'All ' + INTEGRATIONS_COUNT_10s + '+ Integrations',
    class: 'text-bold text-md mb-4 text-white uppercase flex items-center',
    container_class: 'mb-2 mt-2 w-full',
    icon: 'material-symbols:chevron-right-rounded',
    link: '/integrations',
} satisfies TMenuItem);

const NAV_MENU: TMenu[] = [
    {
        title: 'Products',
        items: [
            {
                title: 'Unified API',
                link: '/technology',
            },
            {
                title: 'Unified MCP',
                link: '/mcp',
                // badge: 'New',
            },
            {
                title: 'Unified Business Login',
                link: '/login',
            },
            {
                title: 'Unified SCIM API',
                link: '/scim',
            },
            {
                title: 'Unified API CLI',
                link: 'https://github.com/unified-to/unified-cli'
            }
        ]
    },
    {
        title: 'Solutions',
        items: unified_apis
    },
    {
        title: 'API Docs',
        items: [
            {
                title: 'Introduction',
                link: 'https://docs.unified.to/intro',
            },
            {
                title: 'How-to Guides',
                link: 'https://docs.unified.to/guides',
            },
            {
                title: 'MCP Server Docs',
                link: 'https://docs.unified.to/mcp/overview',
            },
            {
                title: 'Build with Agents',
                link: '/agents',
            },
            {
                title: 'GitHub Repositories',
                link: 'https://github.com/unified-to',
            },
            {
                title: 'Postman Collections',
                link: 'https://www.postman.com/unified-to/unified-api-workspace/overview',
            },
        ]
    },
    {
        title: 'Resources',
        items: [
            // {
            //     title: 'API Documentation',
            //     link: 'https://docs.unified.to',
            // },
            {
                title: 'Security',
                link: '/security',
            },
            {
                title: 'Blog',
                link: '/blog',
            },
            // {
            //     title: 'Why Unified is Different',
            //     link: '/technology',
            // },
            {
                title: 'Customer Case Studies',
                link: '/casestudies',
            },
            {
                title: 'Embedded Authorization',
                link: '/embeddedauth',
            },

            // {
            //     title: 'Certification Trust Center',
            //     link: 'https://app.mycroft.io/trust/unified-to',
            // },
            {
                title: 'Changelog',
                link: '/changelog',
            },
            {
                title: 'For Product Managers',
                link: '/productmanagers',
            }
        ]
    },

    {
        title: 'Unified',
        items: [
            {
                title: 'Contact Unified',
                link: '/contact',
            },

            {
                title: 'About Unified',
                link: '/about',
            },
            {
                title: 'Customer Reviews',
                link: 'https://www.g2.com/products/unified-to/reviews',
            },

            // {
            //     title: 'LinkedIn Company Page',
            //     link: 'https://www.linkedin.com/company/unified-to/',
            // },
            {
                title: 'Public Technical Support',
                link: 'https://discord.gg/85z7HF7JbD',
            },

        ]
    },
    {
        title: 'Pricing',
        link: '/pricing',
    },
]

const LOGIN_MENU: TMenu[] = [
    {
        title: '',
        icon: 'ic:baseline-discord',
        link: 'https://discord.gg/85z7HF7JbD',
        hint: 'Ask us questions in Discord',
        left_margin: false,
    },
    {
        title: 'Sign in',
        link: 'https://app.unified.to',
        left_margin: false,
    },
    {
        title: 'Start Free',
        link: 'https://app.unified.to/login',
        outline: true,
    }] satisfies TMenu[];

const NAV_MENU_MOBILE: IMenuItem[] = NAV_MENU.map(item => ({
    name: item.title,
    link: item.link,
    items: item.items,
})).concat(LOGIN_MENU.map(item => ({
    name: item.title,
    link: item.link,
    items: item.items,
})));


export default {
    data() {
        return {
            // CATS,
            // MAP_CATS,
            showDiscord: true,
            isOpen: false,
            NAV_MENU,
            NAV_MENU_MOBILE,
            /*
            navigation_menu: [
                {
                    name: 'Product',
                    sections: [
                        {
                            title: 'Solutions',
                            items: [
                                {
                                    name: 'Unified API',
                                    link: '/integrations',
                                },
                                {
                                    name: 'Unified MCP',
                                    link: '/mcp',
                                    badge: 'New'
                                },
                                {
                                    name: 'Unified Business Login',
                                    link: '/login',
                                },
                                {
                                    name: 'Unified SCIM API',
                                    link: '/scim'
                                }
                            ]
                        },
                        // {
                        //     title: 'Unified APIs',
                        //     items: CATEGORIES.map(c => ({ ...c, name: c.name.replace('Unified ', '') })),
                        //     split: 11
                        // }
                    ].concat(Object.entries(CLUSTERS).map(([name, categories]) => ({
                        title: name,
                        items: categories.map(c => ({ name: `Unified ${MAP_CATS[c]}`, link: `/${c}`, badge: NEW_CATEGORIES.includes(c) ? 'New' : undefined })),
                    })))
                },
                {
                    name: 'Resources',
                    sections: [
                        {

                            items: [
                                {
                                    name: 'Blog',
                                    link: '/blog',
                                },
                                {
                                    name: 'Why Unified is Different',
                                    link: '/technology',
                                },
                                {
                                    name: 'Customer Case Studies',
                                    link: '/casestudies',
                                },
                                {
                                    name: 'Unified Authorization',
                                    link: '/embeddedauth',
                                },
                                {
                                    name: 'Security',
                                    link: '/security',
                                },
                                {
                                    name: 'Certification Trust Center',
                                    link: 'https://app.mycroft.io/trust/unified-to',
                                    target: '_blank',
                                },
                                {
                                    name: 'Product Changelog',
                                    link: '/changelog',
                                },
                            ]
                        },
                    ],
                },
                {
                    name: 'Pricing',
                    link: '/pricing',
                },
                {
                    name: 'API Docs',
                    link: 'https://docs.unified.to',
                },
                {
                    name: 'Contact',
                    sections: [
                        {
                            items: [
                                {
                                    name: 'Contact Unified',
                                    link: '/contact'
                                },
                                {
                                    name: 'Technical Support Discord Server',
                                    link: 'https://discord.gg/85z7HF7JbD'
                                },
                                {
                                    name: 'About Unified',
                                    link: '/about'
                                },
                                {
                                    name: 'G2 Customer Reviews',
                                    link: 'https://www.g2.com/products/unified-to/reviews',
                                    target: '_blank',
                                },
                                // {
                                //     name: 'YouTube Channel',
                                //     link: 'https://www.youtube.com/@unified_api',
                                //     target: '_blank',
                                // },
                                {
                                    name: 'GitHub Repositories',
                                    link: 'https://github.com/unified-to',
                                    target: '_blank',
                                },
                                // {
                                //     name: 'LinkedIn Company Page',
                                //     link: 'https://www.linkedin.com/company/unified-to/',
                                //     target: '_blank',
                                // },
                                {
                                    name: 'Postman Collections',
                                    link: 'https://www.postman.com/unified-to/unified-api-workspace/overview',
                                    target: '_blank',
                                }
                            ]
                        }
                    ]
                },
            ] as IMenuItem[],
            */

            login_menu: LOGIN_MENU
        };
    },
};
</script>